import styled from 'styled-components';

interface IProps {
  path: string;
}

export const Container = styled.div<IProps>`
  min-height: 80px;

  ${({ path }) => {
    switch (path) {
      case '/': {
        return `
          background: #e2f1ff;
        `
      }
      default : {
        return `
          background: var(--blue00);
          background: linear-gradient(90deg, rgba(0,105,182,1) 0%, rgba(0,120,208,1) 10%)
        `
      }
    }}}
`;

export const Content = styled.div`
  width: 100%;
  height: fit-content;

  display: flex;
  align-items: center;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    max-width: 1100px;
    height: fit-content;

    margin: 10px auto 0;
    padding: 5px;
  }

  @media (min-width: 1170px) {
    padding-right: 15px;
    padding-left: 250px;
  }
`;

export const Breadcrumb = styled.div<IProps>`
  display: flex;
  align-items: center;

  img {
    width: auto;
    max-width: 55px;
    min-height: 55px;
    margin-right: 30px;
  }

  h1 {
    font-size: 2rem;
    font-weight: bold;
    min-height: 28px;

    ${({ path }) => {
      switch (path) {
        case '/': {
          return `
            color: var(--blue12);
          `
        }
        default : {
          return `
            color: #fff;
          `
        }
      }}}
  }

  @media (max-width: 400px) {
    img{
      height: 40px;
      margin-right: 12px;
    }

    h1{
      font-size: 1.7rem;
    }
  }
`;
